module.exports = __webpack_public_path__ + "img/bell.4516d1cf.svg";